import * as react from "react";

export function useIsComponentMounted() {
    const isComponentMounted = react.useRef(false);
    react.useEffect(() => {
        const disp = (() => {
        isComponentMounted.current = true;
        return {
            Dispose() {
                isComponentMounted.current = false;
            },
        };
    })();
        return () => disp.Dispose();
    }, []);
    return isComponentMounted;
}

